import { render, staticRenderFns } from "./FaseFenologica.vue?vue&type=template&id=bf1f272e"
import script from "./FaseFenologica.vue?vue&type=script&lang=js"
export * from "./FaseFenologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports